module.exports = "<p>assign-mysteryshopper works!</p>\r\n"